<template>	
	<main>
		<section class="vx-row">
			<!-- Card Main -->
			<div class="vx-col w-full ">
				<home-slider :data="slider" />
				<home-service />
				<home-topup />
				<home-donation-links />
        <!-- Popular Campaign -->
        <div>
          <header class="flex justify-between w-full items-center mb-4">
            <h5 class="mr-6"><strong class="text-primary">Donasi Pilihan ZX</strong></h5>
            <router-link to="/zxcare" class="text-primary">
              <small>Lihat Semua &nbsp;&nbsp;&nbsp;>></small>
            </router-link>
          </header>

          <div v-if="campaign.length > 0">
            <campaign-slider :data="campaign" />
          </div>
          <div v-else class="text-center my-12">
            <h4 class="text-grey">Belum ada donasi yang dibuat.</h4>
          </div>
        </div>
        <!-- / -->

        <!-- Urgent Campaign -->
        <div>
          <header class="flex justify-between w-full items-center mb-4">
            <h5 class="mr-6"><strong class="text-primary">Donasi Mendesak</strong></h5>
            <router-link to="/zxcare" class="text-primary">
              <small>Lihat Semua &nbsp;&nbsp;&nbsp;>></small>
            </router-link>
          </header>
  
          <div v-if="urgentCampaign.length > 0">
            <campaign-slider :data="urgentCampaign" />
          </div>
          <div v-else class="text-center my-12">
            <h4 class="text-grey">Belum ada donasi yang dibuat.</h4>
          </div>

        </div>
        <!-- / -->

        <home-qurban :datas="qurbans" />
        <home-choice-mitra />
			</div>
			<!-- / -->
		</section>
	</main>
</template>
<script>
import HomeSlider from './components/HomeSlider.vue'
import HomeService from './components/HomeService.vue'
import HomeTopup from './components/HomeTopup.vue'
import HomeDonationLinks from './components/HomeDonationLinks.vue'
import HomeChoiceMitra from './components/HomeMitraPilihan.vue'
import { mapState } from 'vuex'

export default {
  components: {
    HomeChoiceMitra,
    HomeSlider,
    HomeService,
    HomeTopup,
    HomeDonationLinks,
    CampaignSlider: () => import('@/views/home/campaign/components/CampaignSlider.vue'),
    HomeQurban: () => import('@/views/home/qurban/components/QurbanCarousel.vue')
  },
  computed: {
    ...mapState('campaign', ['campaign']),
    qurbans: {
      get() {
        return this.$store.state.qurban.qurbans
      },
      set(datas) {
        return this.$store.dispatch('qurban/setDataQurban', datas)
      }
    }
  },
  data: () => ({
    data: [],
    urgentCampaign: [],
    slider: [
      {
        file_url: '/assets/images/banner/zx.png'
      },
      {
        file_url: '/assets/images/banner/zx.png'
      },
      {
        file_url: '/assets/images/banner/zx.png'
      }
    ],
  }),
  methods: {
    getQurban() {
      const params = {
        length: 12,
        status: 1,
        ord: 'desc'
      };

      this.$store.dispatch('qurban/getData', params)
      .catch(e => {
        console.error(e)

        return false
      });
    },
    getCampaign () {
      const params = {
        start: 0,
        length: 9,
        status: 1
      };

      const self = this;

      this.$store.dispatch('campaign/getData', {params, mutation: 'SET_DATA'})
      .then(function(datas) {
        self.$store.commit('campaign/SET_POPULAR', 3)
        const urgentCampaign = datas.filter(item => item.status_priority === 1)
        self.$store.dispatch('campaign/setUrgentCampaign', urgentCampaign)
      })
      .catch(e => console.error(e));
    },
    getBanner () {
      this.$store.dispatch('banner/getData')
        .then(banner => {
          if (banner.length > 0) {
            this.slider = banner
          }
        })
    },
    getCategoryCampaign() {
      this.$store.dispatch('campaign/getCategory')
      .catch(e => {
        console.error(e)
        return false
      })
    }
  },
  mounted () {
    this.getCampaign();
    this.getCategoryCampaign();
    this.getBanner();
    this.getQurban();
    // Watch for state changes
    this.$store.watch(
      (state) => {
        return this.$store.getters['campaign/urgentCampaign']
      },
      (val) => {
        if(val) {
          this.urgentCampaign = val;
        }
      },
      {
        deep: true
      }
    );
  }
}
</script>